// Core
import React from 'react';

// Libraries
import { useTranslation } from 'react-i18next';

// Components
import { NavigationTabs } from '../../../../../../layout/elements/NavigationTabs';

// Modules
import { Automation } from './Modules/Automation';
import { Crusher } from './Modules/Crusher';
import { Lubrication } from './Modules/Lubrication';
import { Vibration } from './Modules/Vibration';

// Types
import {
  SetpointItemTab,
  SetpointProps,
  SetpointType,
} from './Setpoint.types';
import {
  Container,
  FixedHeader,
  ScrollableContent,
  Separator,
} from './Setpoint.style';

function Setpoint({
  className,
  edgeStatus,
  onChangeView,
  selectedView,
  testId,
  unitData,
}: SetpointProps): JSX.Element | null {
  // Dependencies
  const { t } = useTranslation();

  const changeSetPoint: SetpointItemTab[] = [
    { key: SetpointType.crusher, label: `${t('common.equipmentCategory.crusher.singular')}` },
    { key: SetpointType.lubrication, label: `${t('common.lubrication')}` },
    { key: SetpointType.vibration, label: `${t('common.vibration')}` },
    { key: SetpointType.automation, label: `${t('common.automation')}` },
  ];

  const renderContent = (): JSX.Element => {
    let content: JSX.Element;

    if (selectedView === SetpointType.crusher) {
      content = <Crusher unitData={unitData} />;
    } else if (selectedView === SetpointType.automation) {
      content = <Automation unitData={unitData} edgeStatus={edgeStatus} />;
    } else if (selectedView === SetpointType.lubrication) {
      content = <Lubrication unitData={unitData} />;
    } else if (selectedView === SetpointType.vibration) {
      content = <Vibration unitData={unitData} />;
    } else {
      content = <Crusher unitData={unitData} />;
    }

    return content;
  };

  return (
    <Container className={className} data-testid={testId}>
      <FixedHeader>
        <NavigationTabs
          items={changeSetPoint}
          onClick={onChangeView}
          selected={selectedView}
        />
        <Separator />
      </FixedHeader>
      <ScrollableContent>{renderContent()}</ScrollableContent>
    </Container>
  );
}

export { Setpoint };
